import React from 'react';
import { IIconProps } from '../interfaces';

const AleaPhoneIcon: React.FC<IIconProps> = ({ size = '20' }) => {
  const width = parseInt(String(size), 10);
  const height = width; // Aspect ratio 1:1 based on viewBox 0 0 36 36

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        fill="#BE1931"
        d="M36 11.5C36 8.462 33 4 18 4S0 8.462 0 11.5c0 .045.019.076.022.119-.012.196-.022.402-.022.631C0 14.873 2.239 16 5 16s5-1.127 5-3.75a3.7 3.7 0 0 0-.051-.597C12.374 11.302 15.102 11 18 11s5.626.302 8.051.653a3.7 3.7 0 0 0-.051.597c0 2.623 2.238 3.75 5 3.75s5-1.127 5-3.75c0-.225-.009-.429-.024-.621.004-.046.024-.08.024-.129"
      />
      <path
        fill="#DD2E44"
        d="M34.934 23c-.482-1.031-2.31-4.19-3.968-7.007C29.408 13.346 27 11 25 11V9a2 2 0 0 0-4 0v2h-6V9a2 2 0 0 0-4 0v2c-2 0-4.41 2.351-5.97 5-1.657 2.815-3.483 5.97-3.964 7C.488 24.239 0 25 0 27s1.791 5 4 5h28c2.209 0 4-3 4-5s-.448-2.676-1.066-4"
      />
      <path
        fill="#FFF"
        d="M20.046 14.818c0 .452-.916.818-2.046.818s-2.045-.366-2.045-.818S16.87 14 18 14s2.046.366 2.046.818m-4.91 0c0 .452-.915.818-2.045.818s-2.045-.366-2.045-.818.916-.818 2.045-.818 2.045.366 2.045.818m9.818 0c0 .452-.915.818-2.045.818s-2.046-.366-2.046-.818.916-.818 2.046-.818 2.045.366 2.045.818m-4.5 2.864c0 .679-1.099 1.228-2.454 1.228s-2.455-.549-2.455-1.228c0-.677 1.099-1.227 2.455-1.227s2.454.549 2.454 1.227m5.728 0c0 .679-1.1 1.228-2.454 1.228s-2.455-.549-2.455-1.228c0-.677 1.1-1.227 2.455-1.227s2.454.549 2.454 1.227m-11.455 0c0 .679-1.099 1.228-2.454 1.228s-2.455-.549-2.455-1.228c0-.677 1.099-1.227 2.455-1.227 1.355 0 2.454.549 2.454 1.227m6.545 3.681C21.272 22.269 19.807 23 18 23s-3.273-.731-3.273-1.637c0-.903 1.466-1.636 3.273-1.636 1.807.001 3.272.733 3.272 1.636m7.365 0c0 .905-1.467 1.637-3.273 1.637s-3.273-.731-3.273-1.637c0-.903 1.466-1.636 3.273-1.636 1.806.001 3.273.733 3.273 1.636m-14.728 0c0 .905-1.466 1.637-3.273 1.637s-3.272-.731-3.272-1.637c0-.903 1.465-1.636 3.272-1.636 1.807.001 3.273.733 3.273 1.636"
      />
    </svg>
  );
};

export default AleaPhoneIcon;
